/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAssistPhoneNumberDto } from '../models/CreateAssistPhoneNumberDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AssistPhoneNumberService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public create(
        requestBody: CreateAssistPhoneNumberDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/assist-phone-number',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public getAll(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/assist-phone-number',
        });
    }

}
